import { Button, Icon, Tooltip } from '@patternfly/react-core';
import { HistoryIcon } from '@patternfly/react-icons';
import * as React from 'react';

export interface ChangeLogButtonProps {
  /** Opens the change log panel for this row. */
  onClick(): void;
  /** The record, for the tooltip and the accessible name: "Change log of RH124". */
  recordLabel?: string;
  isDisabled?: boolean;
}

/**
 * The way into a record's change log from a row, for the entities whose page *is* a table.
 *
 * The registry covers records with no detail page of their own - private courses, Red Hat regions,
 * instructor custom fields - where the row is the record and there is no page-actions kebab to hang
 * a Change log option on. Sits in the row's action list beside Edit and Remove, so all three pages
 * offer it in the same place, and reads the same as the kebab option the detail pages carry.
 */
export const ChangeLogButton: React.FunctionComponent<ChangeLogButtonProps> = ({
  onClick,
  recordLabel,
  isDisabled = false
}) => (
  <Tooltip content={recordLabel ? `Change log of ${recordLabel}` : 'Change log'}>
    <Button
      icon={<Icon size="lg"><HistoryIcon /></Icon>}
      variant="plain"
      aria-label={recordLabel ? `Change log of ${recordLabel}` : 'Change log'}
      onClick={onClick}
      isDisabled={isDisabled}
    />
  </Tooltip>
);
